module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"subject":"Subject: {subject}","from":"From:","to":"To:","date":"Date:"},"es":{"subject":"Motivo: {subject}","from":"De:","to":"Para:","date":"Fecha:"}}')
  delete Component.options._Ctor
}
